import React from 'react';
import { Col, Row } from 'react-bootstrap5';

import Modules from './Modules';
import CoachFeedback from './CoachFeedback';
import SessionFeedback from './SessionFeedback';
import ProgramFeedback from './ProgramFeedback';
import SessionsStatistics from './SessionsStatistics';

export default function Index() {
  return (
    <>
      <h3 className="mt-5 mb-3">Utilization</h3>

      <Row>
        <Col lg="4" className="mb-2 mb-lg-0">
          <Modules />
        </Col>

        <Col lg="4" className="mb-2 mb-lg-0">
          <div className="h-100 border border-2 rounded-3 p-3">
            <CoachFeedback />
            <SessionFeedback />
            <ProgramFeedback />
          </div>
        </Col>

        <Col lg="4" className="mb-2 mb-lg-0">
          <SessionsStatistics />
        </Col>
      </Row>
    </>
  );
}
